const computedStyle = {
  get: (value) => {
    const style = window.getComputedStyle(document.body);
    return style.getPropertyValue(value);
  }
};

export default computedStyle;
